export const FAQ_TYPE_CLIENT = 1;
export const FAQ_TYPE_CARDHOLDER = 2;
export const FAQ_KEY_BANKS = "banks";
